import React, { forwardRef, useId } from 'react';
import Field, { errorId, hintId } from '../Field/Field';
import { cx, describedBy } from '../utils';
import './Input.css';

// className — <input> ga, wrapperClassName — tashqi o'ramaga.
// rightElement — input ichida o'ng tomonda (masalan parolni ko'rsatish tugmasi).
// Qolgan barcha prop'lar (name, value, onChange, type, placeholder ...) <input> ga uzatiladi.
const Input = forwardRef(function Input(
  {
    id,
    label,
    hint,
    error,
    leftIcon,
    rightElement,
    disabled,
    required,
    className,
    wrapperClassName,
    'aria-describedby': ariaDescribedBy,
    ...rest
  },
  ref
) {
  const autoId = useId();
  const inputId = id || autoId;

  return (
    <Field
      id={inputId}
      label={label}
      hint={hint}
      error={error}
      required={required}
      className={wrapperClassName}
    >
      <div className={cx('ui-control', leftIcon && 'ui-control--has-left', rightElement && 'ui-control--has-right', error && 'ui-control--invalid')}>
        {leftIcon && <span className="ui-control__icon ui-control__icon--left">{leftIcon}</span>}
        <input
          {...rest}
          ref={ref}
          id={inputId}
          disabled={disabled}
          required={required}
          aria-invalid={error ? true : undefined}
          aria-describedby={describedBy(
            error ? errorId(inputId) : hint && hintId(inputId),
            ariaDescribedBy
          )}
          className={cx('ui-control__field', 'ui-input', className)}
        />
        {rightElement && <span className="ui-control__right">{rightElement}</span>}
      </div>
    </Field>
  );
});

export default Input;
